// extracted by mini-css-extract-plugin
export default {"confirmBtn":"Button_confirmBtn__zkcj4","buyBtn":"Button_buyBtn__ZrPY4","cancelBtn":"Button_cancelBtn__neuir","Remove":"Button_Remove__XnIiq","confrimBtn":"Button_confrimBtn__iUpig"};